/**
 * Maps CancellationStatus enum values to their UI display text.
 */
export const CANCELLATION_STATUS_DISPLAY_MAP: Record<string, string> = {
  CancellationRequested: 'Cancellation Requested',
  CancellationPending: 'Pending cancellation',
  CancellationDenied: 'Cancellation Denied',
};

/**
 * Returns true if the cancellation status is active (not null, undefined, or 'Blank').
 */
export function hasCancellationStatus(status: string | null | undefined): boolean {
  return !!status && status !== 'Blank';
}

/**
 * Returns the display text for cancellation status, or null if no active cancellation.
 * When null is returned, the caller should fall back to the regular settlement substatus.
 */
export function getCancellationDisplayText(cancellationStatus: string | null | undefined): string | null {
  if (!hasCancellationStatus(cancellationStatus)) {
    return null;
  }
  return CANCELLATION_STATUS_DISPLAY_MAP[cancellationStatus!] || cancellationStatus!;
}
